import React from 'react';
import {Route, Switch} from 'react-router-dom';
import MinhasContribuicao from './pages/MinhasContribuicao';

import './assets/minhas-contribuicoes.scss'

const MinhasContribuicoesPage: React.FC = () => {
  return (
    <>
      <Switch>
        <Route path="/minhas-contribuicoes/inicio" exact={true} component={MinhasContribuicao}/>
      </Switch>
    </>
  );
};
export default MinhasContribuicoesPage;
